export default {
  Unauthorized: 401,
  NotPermissions: 403,
  NotFound: 404,
  Conflict: 409,
  Gone: 410,
  UnprocessableEntity: 422,
  Locked: 423,
  InternalServerError: 500,
  BadRequest: 400
};



// WEBPACK FOOTER //
// ./src/constants/http-status-codes.js